/// <reference types="vite/client" />

/**
 * Runtime configuration, read once from Vite's `import.meta.env`. All values are
 * environment-specific (see `.env.example`); none are secrets (the MSAL SPA flow
 * is a public client). Real values are pending the Entra registration + Admin
 * service (property-vault/pv-mono#64, #66).
 */
export interface AdminEnv {
    entraClientId: string;
    entraTenantId: string;
    entraRedirectUri: string;
    adminApiScope: string;
    adminGroupId: string;
    adminApiUrl: string;
}

function required(value: string | undefined, name: string): string {
    if (!value) {
        // Fail loud at boot rather than mid-flow with a cryptic MSAL/Relay error.
        throw new Error(
            `Missing required environment variable ${name}. Copy apps/admin/admin-web/.env.example to .env.local and fill it in.`,
        );
    }
    return value;
}

export function readEnv(): AdminEnv {
    const e = import.meta.env;
    return {
        entraClientId: required(e.VITE_ENTRA_CLIENT_ID, 'VITE_ENTRA_CLIENT_ID'),
        entraTenantId: required(e.VITE_ENTRA_TENANT_ID, 'VITE_ENTRA_TENANT_ID'),
        // Redirect URI defaults to the current origin so preview/deploy URLs work
        // without per-environment rebuilds (must also be registered on the SPA app).
        entraRedirectUri: e.VITE_ENTRA_REDIRECT_URI || window.location.origin,
        adminApiScope: required(e.VITE_ADMIN_API_SCOPE, 'VITE_ADMIN_API_SCOPE'),
        adminGroupId: required(e.VITE_ADMIN_GROUP_ID, 'VITE_ADMIN_GROUP_ID'),
        adminApiUrl: required(e.VITE_ADMIN_API_URL, 'VITE_ADMIN_API_URL'),
    };
}
